import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=1839e286&scoped=true"
import script from "./TemplateList.vue?vue&type=script&lang=js"
export * from "./TemplateList.vue?vue&type=script&lang=js"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=1839e286&prod&lang=scss&scoped=true"
import style1 from "./TemplateList.vue?vue&type=style&index=1&id=1839e286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839e286",
  null
  
)

export default component.exports